import Phaser from 'phaser';
import { COIN } from '../config/GameConfig';

/**
 * Coin —— 金币（圆形 + "$" 图标）
 *
 * 慢速下落；玩家进入吸附半径会被加速度拉过去（见 MainScene._updateCoinMagnet）
 */
export default class Coin extends Phaser.GameObjects.Container {
  declare body: Phaser.Physics.Arcade.Body;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    scene.add.existing(this);
    scene.physics.add.existing(this);

    const r = COIN.radius;
    const ring = scene.add.circle(0, 0, r + 2, COIN.borderColor, 1);
    const body = scene.add.circle(0, 0, r, COIN.color, 1);
    body.setStrokeStyle(2, COIN.borderColor, 1);
    const dollar = scene.add
      .text(0, 0, '$', {
        fontFamily: 'sans-serif',
        fontSize: '14px',
        fontStyle: 'bold',
        color: '#7a5810',
      })
      .setOrigin(0.5);
    this.add([ring, body, dollar]);

    this.body.setCircle(r);
    this.body.setOffset(-r, -r);
    this.body.setVelocity(0, COIN.speed);
    this.body.setAllowGravity(false);

    scene.tweens.add({
      targets: dollar,
      alpha: { from: 1, to: 0.4 },
      duration: 500,
      yoyo: true,
      repeat: -1,
    });
  }
}
